<template>
  <div>
    <div>
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </div>

    <!-- campos de resumo -->
    <filling-details-summary-fields :fields="model.summaryFields">
    </filling-details-summary-fields>

    <!-- proximo status -->
    <b-row v-if="model.stageNext != 0">
      <b-col lg="6" md="6" sm="12">
        <b-form-group label="Próxima etapa">
          <b-form-select
            class="status"
            :options="model.stageNext"
            v-model="statusId"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <div v-if="loadFields">
      <div class="text-center my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t("geral.loadingData") }}</strong>
      </div>
    </div>
    <!-- campos -->
    <b-row v-for="field in nextStageFill.fields" :key="field.fieldId">
      <b-col>
        <workflow-fill-field
          :fieldId="field.fieldId"
          :field="field"
          :modelstate="modelstate"
          :stage="true"
          :driverFields.sync="driverFields"
        ></workflow-fill-field>
      </b-col>
    </b-row>

    <b-row v-if="nextStageFill.allowComment" mt="3">
      <b-button
        v-if="!allowNewComment"
        class="ml-3"
        size="sm"
        @click="newComment"
      >
        Novo comentário
      </b-button>
      <b-col v-if="allowNewComment">
        <label for="">Novo comentário:</label>
        <b-form-textarea
          id="input-description"
          v-model="nextStageFill.comment"
          placeholder="Escrever um comentário..."
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "FillingDetailsNextStage",
  components: {
    "fade-alert-danger": () => import("@/components/FadeAlertDanger.vue"),
    "filling-details-summary-fields": () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/FillingDetails/FillingDetailsSummaryFields.vue"
      ),
    "workflow-fill-field": () =>
      import("@/components_rms/workflow/WorkflowFillField.vue"),
  },
  props: {
    processFilledId: String,
    isSubmitting: Boolean,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Processo editado com sucesso",
      },
      allowNewComment: false,
      driverFields: [],
      loadFields: true,
      model: {},
      modelstate: {},
      nextStageFill: {},
      statusId: "",
      originalValues: [],
    };
  },
  computed: {
    isSubmittingProperty: {
      get: function () {
        return this.isSubmitting;
      },
      set: function (value) {
        this.$emit("update:isSubmitting", value);
      },
    },
  },
  mounted() {
    this.model = {};
    this.modelstate = {};
    this.nextStageFill = {};
    this.statusId = "";
    this.getProcess();
  },
  methods: {
    error(err) {
      console.warn("ERROR(" + err.code + "): " + err.message);
    },
    getDataPrazo(fields) {
      for (let field of fields) {
        if (field.fieldName == "Data Prazo") {
          this.driverFields.push(field);
        }
      }
    },
    getStatus() {
      for (let next of this.model.stageNext) {
        this.statusId = next.value;
        break;
      }
    },
    getProcess() {
      this.$apiWorkflow
        .get(
          `v2/stage/next?filledId=${this.processFilledId}&includeAttachmentsOnSummary=true`
        )
        .then((response) => {
          this.model = response.data;
          this.modelstate = {};
          this.getStatus();
          this.getPosition();
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
          console.log(error.response);
          this.model = {};
          this.modelstate = {};
          if (error.response.status == 401) {
            console.log(error.response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              console.log(error.response.data);
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              } else {
                this.modelstate = {};
              }
              this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
              this.$refs.danger.show();
            } else {
              this.modelstate = {};
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          }
        });
    },
    getFields(statusId) {
      if (!statusId) return;
      if (statusId == 0) return;
      this.$apiWorkflow
        .get("/stage/next/fill/" + statusId)
        .then((response) => {
          let nextStageFill = response.data;
          this.getValuesFilled(nextStageFill.fields);
          // for (let field of nextStageFill.fields) {
          //   let value = this.getValue(field);
          //   if (value != null) {
          //     field.id = value.id;
          //     field.value = value.value;
          //     // field.required = value.required;
          //   }
          // }
          for (let field of nextStageFill.summaryFields) {
            let value = this.getValue(field);
            if (value != null) {
              field.id = value.id;
              field.value = value.value;
            }
          }
          this.nextStageFill = nextStageFill;
          this.loadFields = false;
          this.setOriginalValues();
        })
        .catch((error) => {
          this.nextStageFill = {};
          if (error.response.status == 401) {
            console.log(error.response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              } else {
                this.modelstate = {};
              }
              console.log(error.response.data);
              this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
              this.$refs.danger.show();
            } else {
              this.modelstate = {};
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          }
        });
    },
    getListAdditionalField(field) {
      let fields = [];
      if (field.valueList != null) {
        for (let opt of field.valueList) {
          if (opt.id == field.value) {
            if (opt.values != null) {
              for (let aditionalField of opt.values) {
                fields.push(aditionalField);
              }
            }
          }
        }
      }
      return fields;
    },
    getValue(field) {
      if (!this.model) return null;
      if (!this.model.fields) return null;
      for (let value of this.model.fields) {
        if (value.fieldId == field.fieldId) {
          return value;
        }
      }
      return null;
    },
    getValuesFilled(fields) {
      this.driverFields = [];
      this.getDataPrazo(this.model.fields);

      for (let field of fields) {
        if (field.type == 9024 || field.type == 9025) {
          this.driverFields.push(field);
        }

        let value = this.getValue(field);
        if (value != null) {
          field.id = value.id;
          field.value = value.value;
          field.oldValue = value.oldValue;
          // field.required = value.required;

          if (value.attachments != null) {
            for (let attachmentValue of value.attachments) {
              field.attachments.push({
                id: attachmentValue.id,
                active: attachmentValue.active,
                attachment: attachmentValue.attachment,
                attachmentName: attachmentValue.attachmentName,
                createdOn: attachmentValue.createdOn,
              });
            }
          }

          if (field.valueList.length > 0) {
            for (let option of field.valueList) {
              if (option.id == field.value) {
                if (option.hasAdditionalField) {
                  let additionalFieldsValue =
                    this.getListAdditionalField(value);
                  let additionalFieldsField =
                    this.getListAdditionalField(field);
                  for (let additionalValue of additionalFieldsValue) {
                    for (let additionalField of additionalFieldsField) {
                      if (additionalValue.fieldId == additionalField.fieldId) {
                        additionalField.id = additionalValue.id;
                        additionalField.value = additionalValue.value;
                        additionalField.oldValue = additionalValue.oldValue;

                        if (additionalValue.attachments != null) {
                          for (let attachmentValue of additionalValue.attachments) {
                            additionalField.attachments.push({
                              id: attachmentValue.id,
                              active: attachmentValue.active,
                              attachment: attachmentValue.attachment,
                              attachmentName: attachmentValue.attachmentName,
                              createdOn: attachmentValue.createdOn,
                            });
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    getPosition() {
      navigator.geolocation.getCurrentPosition(this.success, this.error);
    },
    async save() {
      this.isSubmittingProperty = true;
      let stage = {
        filledId: this.model.filledId,
        processId: this.model.processId,
        statusId: this.model.statusId,
        latitude: this.model.latitude,
        longitude: this.model.longitude,
        fields: this.nextStageFill.fields,
        stageNext: this.model.stageNext,
        comment: this.nextStageFill.comment,
      };
      await this.$apiWorkflow
        .post("stage/saveFillFields/" + stage.filledId, stage)
        .then((response) => {
          this.isSubmittingProperty = false;
          this.nextStageFill.fields = [];
          this.$emit("refreshData");
          this.model = response.data;
        })
        .catch((error) => {
          this.isSubmittingProperty = false;
          console.log("Error");
          console.log(error);
          console.log(error.response);
          if (error.response.status == 401) {
            console.log(error.response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              console.log(error.response.data);
              if (error.response.data) {
                if (error.response.data.errorMessage) {
                  this.modelstate = {};
                  this.alert.error = `${error.response.data.errorMessage}`;
                  this.$refs.danger.show();
                } else {
                  if (error.response.status == 400) {
                    this.modelstate = error.response.data.errors;
                    this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
                    this.$refs.danger.show();
                  } else {
                    this.modelstate = {};
                    this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
                    this.$refs.danger.show();
                  }
                }
              } else {
                this.modelstate = {};
                this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
                this.$refs.danger.show();
              }
            } else {
              this.modelstate = {};
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          }
        });
    },
    newComment() {
      this.allowNewComment = true;
    },
    setOriginalValues() {
      this.nextStageFill.fields.forEach((field) => {
        this.originalValues.push({
          fieldId: field.fieldId,
          value: field.value,
        });
      });
    },
    success(pos) {
      var crd = pos.coords;
      this.model.latitude = crd.latitude;
      this.model.longitude = crd.longitude;
    },
  },
  watch: {
    statusId() {
      this.model.statusId = this.statusId;
      this.getFields(this.statusId);
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}

.status {
  width: 110%;
}
</style>